import { Time } from '@angular/common';
import { QueryColumn, QueryColumnSortOrder } from '@barthauer/abc/core/data';

export class GeoDsMeta {
  Id: string;
  InsertedDate: Date;
  UpdatedDate: Date;
  SysDateInsert: Date;
  SysDateUpdate: Date;
  SysTimeInsert: Time | string;
  SysTimeUpdate: Time | string;
  SysUserNameInsert: string;
  SysUserNameUpdate: string;

  public static createQueryColumns(): Array<QueryColumn> {
    const queryColumns = new Array<QueryColumn>();
    queryColumns.push(
      {
        Name: 'Id',
        OPath: 'Id',
      },
      {
        Name: 'SysDateInsert',
        OPath: 'SysDateInsert',
        SortOrder: QueryColumnSortOrder.Descending,
      },
      {
        Name: 'SysDateUpdate',
        OPath: 'SysDateUpdate',
      },
      {
        Name: 'SysTimeInsert',
        OPath: 'SysTimeInsert',
        SortOrder: QueryColumnSortOrder.Descending,
      },
      {
        Name: 'SysTimeUpdate',
        OPath: 'SysTimeUpdate',
      },
      {
        Name: 'SysUserNameInsert',
        OPath: 'SysUserNameInsert',
      },
      {
        Name: 'SysUserNameUpdate',
        OPath: 'SysUserNameUpdate',
      }
    );
    return queryColumns;
  }
}
